const ERROR_TRANSLATIONS: Record<string, string> = {
	"Provide either 'month' and 'year', or a 'from' date (optionally with 'to').":
		"Informe mês e ano, ou uma data inicial (opcionalmente com data final).",
	"The value '3' is invalid.": "O valor informado para classificação é inválido."
}

function translateErrorMessage(message: string): string {
	return ERROR_TRANSLATIONS[message] ?? message
}

export function getFilenameFromContentDisposition(header: string | undefined): string | null {
	if (!header) {
		return null
	}

	const utf8Match = header.match(/filename\*=UTF-8''([^;\n]+)/i)
	if (utf8Match?.[1]) {
		return decodeURIComponent(utf8Match[1].trim())
	}

	const filenameMatch = header.match(/filename="?([^";\n]+)"?/i)
	if (filenameMatch?.[1]) {
		return filenameMatch[1].trim()
	}

	return null
}

export async function parseBlobErrorMessage(blob: Blob): Promise<string> {
	const text = await blob.text()

	try {
		const json = JSON.parse(text)

		if (Array.isArray(json.detail) && json.detail[0]) {
			return translateErrorMessage(String(json.detail[0]))
		}

		if (json.errors && typeof json.errors === 'object') {
			const messages = Object.values(json.errors)
				.flat()
				.map((message) => translateErrorMessage(String(message)))

			if (messages.length > 0) {
				return messages.join(' ')
			}
		}

		if (json.title) {
			return translateErrorMessage(String(json.title))
		}

		if (json.message) {
			return translateErrorMessage(String(json.message))
		}
	} catch {
		// Fall through to default message.
	}

	return 'Erro ao gerar relatório.'
}

export async function isCsvWithOnlyHeader(blob: Blob): Promise<boolean> {
	const preview = blob.slice(0, 4096)
	const text = await preview.text()
	const lines = text.split(/\r?\n/).filter((line) => line.trim().length > 0)

	return lines.length <= 1
}

export function downloadBlob(blob: Blob, fileName: string) {
	const url = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.style.display = 'none'
	link.href = url
	link.setAttribute('download', fileName)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}
